<!-- src/App.vue -->
<template>
	<main>
        <!--<header v-if="$route.path !== '/'">
            <img src="./assets/MisPromos_Logo.svg"/>
        </header>-->

		<SideMenu :color="'aqua'" v-if="sideMenuActive" />
		<img src="./assets/menu-arrow.png" class="menu-arrow" v-if="!sideMenuActive && $route.path !== '/'"
		@click="sideMenuActive = true" />
		<router-view />

        <footer v-if="['home', 'cupon', 'descuentos', 'categorias', 'categoriadetalle', 'flashmania', 'historial', 'cerca'].includes($route.path.replaceAll('/', ''))">
            <p><b>¿Algo no salió como esperabas?</b></p>
            <p>Si encuentras alguna incidencia, contáctanos al <a target="blank" href="https://bbvatyc.service-now.com/saemex?id=bbva_hrj_sc_cat_item&sys_id=3360d927db66d3001f43dcd748961986">SAE</a></p>
        </footer>
	</main>
</template>

<script>
import SideMenu from './components/SideMenu.vue'

export default {
	name: 'App',
	components: { SideMenu },
	data() {
		return { sideMenuActive: false }
	},
    methods: {
        isTestMode() {
            const params = new URLSearchParams(document.location.search);
            const test = params.get("test");

            return (test && test === "true") || window.location.href.includes("localhost");
        },

        getFrontURL(){
            return window.location.origin;
        },

        async calcExpiredToken(){
            const rawUserData = localStorage.getItem("userData");

            let userData = null;

            try {
                userData = rawUserData ? JSON.parse(rawUserData) : null;
            } catch (error) {
                console.error("userData no es JSON válido:", rawUserData);

                localStorage.clear();

                if (window.location.pathname !== "/") {
                    alert("Tu sesión es inválida. Por favor inicia sesión nuevamente.");
                    window.location.href = this.getFrontURL();
                }

                return;
            }

            const token = userData?.token;

            // CASO 1: no hay token
            if(!token){
                localStorage.clear();

                if (window.location.pathname === "/") return;

                alert("No tienes sesión iniciada.");
                window.location.href = this.getFrontURL();
                return;
            }

            // Validación con backend
            let result;

            try {
                const response = await fetch('https://promo-colaboradores.ideeo.mx/api/sesion', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ token })
                });

                result = await response.json();
            } catch (error) {
                console.error("Error de red:", error);
                // opcional: no alertar aquí para no ser intrusivo
                return;
            }

            console.log("result", result);

            localStorage.setItem("m_usuario", result?.m_usuario);

            // CASO 2: token expirado o inválido
            if(result.msg == "Expiro token"){
                localStorage.clear();

                if (window.location.pathname === "/") return;

                alert("Tu sesión ha caducado.");
                window.location.href = this.getFrontURL();
                return;
            }

            if(result.msg == "No existe token o expiro"){
                localStorage.clear();

                if (window.location.pathname === "/") return;

                alert("Tu sesión no es válida. Por favor inicia sesión nuevamente.");
                window.location.href = this.getFrontURL();
                return;
            }
        },

        isPublicRoute(path) {
            return (
                path === "/" ||
                path === "/home" ||
                path.includes("cupon") ||
                path === "/cerca" ||
                path.includes("categoriadetalle")
            );
        },

        async registrarVisita(){
            try {
                await fetch('https://promo-colaboradores.ideeo.mx/api/visitas', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        ruta: window.location.pathname
                    })
                });
            } catch (error) {
                console.error("Error registrando visita:", error);
            }
        },
    },

    async mounted(){
        if (!sessionStorage.getItem("visita_registrada")) {
            await this.registrarVisita();
            sessionStorage.setItem("visita_registrada", "true");
        }
    },

    watch: {
        '$route.path': {
            immediate: true,
            handler(path) {
                //if (this.isTestMode()) return;
                if (this.isPublicRoute(path)) return;

                this.calcExpiredToken().catch(error => {
                    console.error(error);
                });
            }
        }
    },
}
</script>

<style>
body{
	margin: 0;
}

@font-face {
    font-family: 'Benton Sans BBVA Book';
    src: url('./assets/bentons_sans_bbva/BentonSansBBVA-Book.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'Benton Sans BBVA Medium';
    src: url('./assets/bentons_sans_bbva/BentonSansBBVA-Medium.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'Benton Sans BBVA Bold';
    src: url('./assets/bentons_sans_bbva/BentonSansBBVA-Bold.ttf') format('truetype');
    font-weight: bold;
    font-style: normal;
}

.DISPLAY{
	display: flex;
    flex-direction: column;
    align-items: center;
    min-height: calc(100vh - 4ch - 6ch);
	padding-top: 40px;
}

.INNER-MARGIN{
	/*border: 1px solid red;*/
	width: calc(100% - 20ch - 2px);
    max-width: 1080px;
	margin-left: 5ch;
}

/* sliders */
.general-slider{
	width: 100%;
    display: flex;
    align-items: center;
    overflow: hidden;
    scroll-behavior: smooth;
}

.slider-buttons{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 2ch;
}

.slider-buttons > button{
    background-color: #EDE8E8;
    border-radius: 100vw;
    border: none;
    width: 1.5ch !important;
    height: 1.5ch !important;
    aspect-ratio: 1/1;
    cursor: pointer;
    margin: 0 0.5ch;
}

.active-btn-true{
    background-color: #1276BF !important;
}

/* RESPONSIVE */
@media all and (max-width:780px){

    .INNER-MARGIN{
        width: calc(90%);
        margin-left: unset;
        max-width: unset;
    }

}
</style>

<style scoped>
.menu-arrow {
	position: fixed;
	top: 2ch;
	left: 2ch;
	width: 6ch;
	cursor: pointer;
	z-index: 2;
}

header{
    height: 6ch;
    display: flex;
    align-items: center;
}

header img{
    margin-left: 10ch;
    height: 75% !important;
    width: fit-content;
    display: flex;
}

footer{
    color: white;
    background-color: #171391;
    padding: 20px 40px;
    font-family: 'Benton Sans BBVA Book';
}

footer b{
    font-family: 'Benton Sans BBVA medium';
}

footer a{
    color: white;
    font-family: 'Benton Sans BBVA bold';
}
</style>

<!--
    Nota:
	Ya no necesitas BbvaConvenios.vue como “switch” por view; ahora cada componente se monta por ruta.
	Si quisieras, puedes conservar BbvaConvenios.vue como layout y poner dentro <router-view/>,
	pero el ejemplo anterior usa App.vue como layout global para que SideMenu persista entre rutas.
-->